"use strict";
// https://github.com/tc39/proposal-throw-expressions 🙏🏽
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line fp/no-nil
exports.default = (function (message) {
    // eslint-disable-next-line fp/no-throw
    throw new Error("MobiledocVdomRenderer: " + message);
});
